var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.13533 13.8711C1.39217 13.8711 0.528884 13.0078 0.528884 11.2979L0.528884 2.89746C0.528884 1.1875 1.39217 0.324219 3.13533 0.324219L11.4693 0.324219C13.1959 0.324219 14.0675 1.1875 14.0675 2.89746L14.0675 4.16748L15.4952 4.16748C17.2218 4.16748 18.0933 5.03076 18.0933 6.74072L18.0933 15.1411C18.0933 16.8511 17.2218 17.7144 15.4952 17.7144L7.16121 17.7144C5.41804 17.7144 4.55476 16.8511 4.55476 15.1411L4.55476 13.8711L3.13533 13.8711ZM3.15193 12.5347L4.55476 12.5347L4.55476 6.74072C4.55476 5.02246 5.41804 4.16748 7.16121 4.16748L12.731 4.16748L12.731 2.97217C12.731 2.10889 12.2662 1.66064 11.4444 1.66064L3.15193 1.66064C2.32185 1.66064 1.86531 2.10889 1.86531 2.97217L1.86531 11.2231C1.86531 12.0864 2.32185 12.5347 3.15193 12.5347ZM11.7598 14.3857C11.9093 14.3857 12.0255 14.2695 12.067 14.1118C12.5401 11.5967 12.7725 11.1235 15.3873 10.7749C15.5533 10.7583 15.6695 10.6255 15.6695 10.4595C15.6695 10.3018 15.5533 10.1772 15.3873 10.1523C12.7808 9.79541 12.4322 9.29736 12.067 6.83203C12.0338 6.66602 11.9093 6.5415 11.7598 6.5415C11.5938 6.5415 11.4776 6.65771 11.4278 6.82373C10.963 9.34717 10.7305 9.79541 8.1241 10.1523C7.94978 10.1772 7.83357 10.3018 7.83357 10.4595C7.83357 10.6255 7.94978 10.75 8.1241 10.7749C10.7388 11.0405 11.0709 11.5967 11.4278 14.1035C11.461 14.2695 11.5772 14.3857 11.7598 14.3857ZM8.38142 15.7803C8.50594 15.7803 8.59724 15.7056 8.63045 15.5894C8.85457 14.3359 8.77156 14.2861 10.1329 14.0786C10.2491 14.0537 10.3404 13.9624 10.3404 13.8462C10.3404 13.7217 10.2491 13.6304 10.1329 13.6138C8.77986 13.3813 8.85457 13.3232 8.63045 12.1113C8.59724 11.9868 8.51424 11.8955 8.38142 11.8955C8.26521 11.8955 8.1822 11.9785 8.1407 12.1113C7.89998 13.3232 8.00789 13.3813 6.64656 13.6138C6.52205 13.6304 6.43904 13.7217 6.43904 13.8462C6.43904 13.979 6.52205 14.0537 6.66316 14.0786C8.00789 14.2861 7.89998 14.3359 8.1407 15.5645C8.1822 15.6973 8.25691 15.7803 8.38142 15.7803Z",
    fill: "url(#paint0_linear_2497_865)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2497_865",
    x1: 9.31111,
    y1: 2,
    x2: 9.31111,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIcon);
export default __webpack_public_path__ + "static/media/Favorite Icon.9856fab49cbe07bc2e4e039faa74aa46.svg";
export { ForwardRef as ReactComponent };